import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(2),
      },
      item: {
        backgroundColor: sicrediColors.secondarySicrediLightest,
        color: sicrediColors.secondarySicrediDarker,
        borderRadius: 4,
        '& .MuiListItemText-primary': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '& > svg': {
            marginRight: theme.spacing(2),
          },
        },
      },
    }),
  { name: 'ComissaoEleitoralModal' }
);
